import Vue from 'vue'

export default {
  createPageView (pageViewData) {
    const headers = { 'Authorization': process.env.VUE_APP_NINKASHI_ANALYTICS_KEY }

    return Vue.prototype.$http.post(
      '/page_view',
      pageViewData,
      { headers }
    )
  }
}
